import moment from 'moment';
import { Badge, Table } from 'react-bootstrap';
import { FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useExhibitorAuthContext } from '../../../Context/AuthContex/ExhibitorAuthContext';
import CommonOnlinePayment from '../../Common/Payment/CommonOnlinePayment';
import { useGetExhibitorInvoiceList } from '../apiEndpoints/exhibitorApiEndpoints';

const BillingInfo = () => {
  const { data, isLoading } = useGetExhibitorInvoiceList();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();

  return (
    <div className='profile-right-side px-3 py-3'>
      <div>
        <h5>Billing Information</h5>
      </div>
      <div className='profile-right-info pt-3 ps-2'>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>SL.</th>
              <th>Date</th>
              <th>Invoice No.</th>
              <th>Amount</th>
              <th>Due</th>
              <th>Status</th>
              <th className='text-center'>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{moment(item.invoice_date).format('DD-MMM-YYYY')}</td>
                <td>{item.invoice_no}</td>
                <td>{item.net_total}</td>
                <td>{item.due}</td>
                <td>
                  <Badge
                    bg={Number(item.due) > 0 ? 'warning' : 'success'}
                    text={Number(item.due) > 0 ? 'dark' : 'light'}
                    style={{ maxWidth: '100px', width: '100%' }}
                  >
                    {Number(item.due) > 0 ? item.status : 'Paid'}
                  </Badge>
                </td>
                <td style={{ textAlign: 'center' }}>
                  <Link
                    to={`/profile/view-billing-info/${item.id}`}
                    className='me-2'
                  >
                    <FaEye color='#00acee' size={23} />
                  </Link>

                  <CommonOnlinePayment
                    invoiceId={item.id}
                    userId={exhibitorUser?.user_fair_member_id}
                    userType={'Exhibitor'}
                    isPaid={item.status === 'Paid' ? 'Paid' : undefined}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default BillingInfo;
